import { Spin } from 'antd';
import PropTypes from 'prop-types';
import './LoadingCard.scss';

const LoadingCard = ({ visible }) => {
  const className = visible ? 'loading-card' : 'loading-card-no-visible';
  return (
    <div className={className}>
      <Spin size="large" />
    </div>
  );
};

LoadingCard.propTypes = {
  visible: PropTypes.bool.isRequired
};

export default LoadingCard;
